import { UseQueryResult } from '@tanstack/react-query';
import { createContext, PropsWithChildren, useContext, useEffect } from 'react';
import { UserPopulatedDTO } from './api/generated';
import { useSpinner } from './SpinnerContext';
import { useCurrentUser } from './utils/useCurrentUser';

export const UserContext = createContext<UseQueryResult<UserPopulatedDTO, Error> | undefined>(undefined);

export function UserProvider(props: PropsWithChildren) {
  const { setLoading } = useSpinner();
  const userQuery = useCurrentUser();

  useEffect(() => {
    setLoading(userQuery.isLoading);
  }, [userQuery.isLoading, setLoading]);

  return <UserContext.Provider value={userQuery}>{props.children}</UserContext.Provider>;
}

export function useUserContext() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
}
